import axios from 'axios';
import { apiService } from './api';

export interface ImageUploadResponse {
  query: string;
  result: {
    url: string;
    presignedUrl: string;
    name: string;
    size: number;
    type: string;
  };
  error: string;
  totalResults: number;
  pageNo: number;
  message: string;
}

class ImageService {
  private static instance: ImageService;

  private constructor() {}

  public static getInstance(): ImageService {
    if (!ImageService.instance) {
      ImageService.instance = new ImageService();
    }
    return ImageService.instance;
  }

  /**
   * Request a presigned URL for a single image upload (feedback screenshots; needs a login).
   * Sends file metadata (size, type) as JSON; the returned URL accepts exactly that file.
   */
  async uploadSingleImage(file: File): Promise<ImageUploadResponse> {
    const data = await apiService.post<
      ImageUploadResponse,
      { size: number; type: string }
    >('/private/api/v1/assets/uploadSingleImage', {
      size: file.size,
      type: file.type,
    });

    // Upload the file to S3 using the presigned URL
    if (data.result?.presignedUrl) {
      await this.uploadToS3(data.result.presignedUrl, file);
    }

    return data;
  }

  async uploadToS3(presignedUrl: string, file: File): Promise<void> {
    await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });
  }
}

export const imageService = ImageService.getInstance();
